/**
 * Famílias Google Fonts mais usadas (busca no editor do banner).
 * Carregadas sob demanda via webfontloader / CSS Google Fonts.
 */
export const GOOGLE_FONT_FAMILIES = [
  'Fraunces',
  'Playfair Display',
  'Cormorant Garamond',
  'Libre Baskerville',
  'Merriweather',
  'Lora',
  'EB Garamond',
  'Crimson Text',
  'Spectral',
  'Cardo',
  'Cinzel',
  'DM Serif Display',
  'Instrument Serif',
  'Bodoni Moda',
  'Inter',
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Poppins',
  'Nunito',
  'Nunito Sans',
  'Raleway',
  'Work Sans',
  'Source Sans 3',
  'DM Sans',
  'Manrope',
  'Outfit',
  'Plus Jakarta Sans',
  'Space Grotesk',
  'Sora',
  'Figtree',
  'Urbanist',
  'Albert Sans',
  'Geist',
  'Oswald',
  'Bebas Neue',
  'Anton',
  'Archivo Black',
  'Barlow Condensed',
  'Roboto Condensed',
  'Fjalla One',
  'Passion One',
  'Righteous',
  'Pacifico',
  'Lobster',
  'Dancing Script',
  'Great Vibes',
  'Satisfy',
  'Caveat',
  'Comfortaa',
  'Quicksand',
  'Josefin Sans',
  'Exo 2',
  'Titillium Web',
  'PT Sans',
  'PT Serif',
  'Noto Sans',
  'Noto Serif',
  'Ubuntu',
  'Rubik',
  'Mulish',
  'Karla',
  'Inconsolata',
  'Fira Sans',
  'Barlow',
  'Cabin',
  'Overpass',
  'Red Hat Display',
  'Lexend',
  'Public Sans',
  'IBM Plex Sans',
  'IBM Plex Serif',
  'Bitter',
  'Abril Fatface',
  'Alfa Slab One',
  'Alegreya',
  'Alegreya Sans',
  'Archivo',
  'Asap',
  'Assistant',
  'Bricolage Grotesque',
  'Cabin Condensed',
  'Catamaran',
  'Chivo',
  'Commissioner',
  'Domine',
  'Epilogue',
  'Fredoka',
  'Gelasio',
  'Heebo',
  'Hind',
  'Jost',
  'Kanit',
  'Libre Franklin',
  'Literata',
  'Maven Pro',
  'Mukta',
  'Newsreader',
  'Oxanium',
  'Philosopher',
  'Prompt',
  'Radio Canada',
  'Saira',
  'Signika',
  'Syne',
  'Teko',
  'Trirong',
  'Varela Round',
  'Vollkorn',
  'Yanone Kaffeesatz',
  'Yeseva One',
  'Zilla Slab',
  'Amatic SC',
  'Arimo',
  'Arvo',
  'Bangers',
  'Bowlby One',
  'Bree Serif',
  'Calistoga',
  'Caveat Brush',
  'Chakra Petch',
  'Concert One',
  'Cookie',
  'Courgette',
  'Crete Round',
  'Cuprum',
  'Didact Gothic',
  'Economica',
  'Electrolize',
  'Encode Sans',
  'Expletus Sans',
  'Francois One',
  'Gloock',
  'Graduate',
  'Gruppo',
  'Hammersmith One',
  'Hind Siliguri',
  'Iceberg',
  'Indie Flower',
  'Julius Sans One',
  'Kalam',
  'Khand',
  'Knewave',
  'Krona One',
  'Lemon',
  'Limelight',
  'Luckiest Guy',
  'Marcellus',
  'Merienda',
  'Monoton',
  'Mrs Saint Delafield',
  'Neucha',
  'Old Standard TT',
  'Orbitron',
  'Pathway Gothic One',
  'Patrick Hand',
  'Permanent Marker',
  'Poiret One',
  'Prata',
  'Press Start 2P',
  'Quattrocento',
  'Racing Sans One',
  'Rajdhani',
  'Rammetto One',
  'Ranga',
  'Reenie Beanie',
  'Rock Salt',
  'Rozha One',
  'Russo One',
  'Sacramento',
  'Sanchez',
  'Secular One',
  'Shadows Into Light',
  'Share Tech Mono',
  'Silkscreen',
  'Six Caps',
  'Special Elite',
  'Staatliches',
  'Syncopate',
  'Tangerine',
  'Tenor Sans',
  'Unica One',
  'UnifrakturMaguntia',
  'VT323',
  'Vast Shadow',
  'Wallpoet',
  'Yellowtail',
  'Zen Dots',
  'Aclonica',
  'Advent Pro',
  'Aldrich',
  'Allerta',
  'Anonymous Pro',
  'Audiowide',
  'Averia Serif Libre',
  'Bai Jamjuree',
  'BenchNine',
  'Black Ops One',
  'Boogaloo',
  'Bubbler One',
  'Cantarell',
  'Capriola',
  'Carter One',
  'Ceviche One',
  'Changa',
  'Chelsea Market',
  'Coda',
  'Coming Soon',
  'Contrail One',
  'Covered By Your Grace',
  'Damion',
  'Days One',
  'Dela Gothic One',
  'Dokdo',
  'East Sea Dokdo',
  'El Messiri',
  'Emilys Candy',
  'Faster One',
  'Fauna One',
  'Fugaz One',
  'Galada',
  'Gilda Display',
  'Gloria Hallelujah',
  'Gochi Hand',
  'Grandstander',
  'Handlee',
  'Happy Monkey',
  'Homemade Apple',
  'IM Fell English',
  'Irish Grover',
  'Italiana',
  'Jacques Francois',
  'Julee',
  'Just Another Hand',
  'Kaushan Script',
  'Kelly Slab',
  'Kristi',
  'La Belle Aurore',
  'Leckerli One',
  'Life Savers',
  'Lilita One',
  'Londrina Solid',
  'Love Ya Like A Sister',
  'Macondo',
  'Maiden Orange',
  'Markazi Text',
  'Megrim',
  'Metal Mania',
  'Miltonian',
  'Modak',
  'Mogra',
  'Mr Dafoe',
  'Nothing You Could Do',
  'Nova Square',
  'Offside',
  'Oregano',
  'Original Surfer',
  'Ovo',
  'Parisienne',
  'Paytone One',
  'Peralta',
  'Petit Formal Script',
  'Piedra',
  'Pirata One',
  'Plaster',
  'Pompiere',
  'Princess Sofia',
  'Prosto One',
  'Purple Purse',
  'Quantico',
  'Quando',
  'Rakkas',
  'Rancho',
  'Ribeye',
  'Risque',
  'Roboto Slab',
  'Rouge Script',
  'Rye',
  'Sail',
  'Salsa',
  'Sancreek',
  'Sarina',
  'Seaweed Script',
  'Sevillana',
  'Shrikhand',
  'Sigmar One',
  'Simonetta',
  'Skranji',
  'Smokum',
  'Snowburst One',
  'Sofia',
  'Sonsie One',
  'Spicy Rice',
  'Spirax',
  'Stalemate',
  'Stardos Stencil',
  'Stint Ultra Condensed',
  'Sunshiney',
  'Supermercado One',
  'Trade Winds',
  'Ubuntu Condensed',
  'Ultra',
  'Uncial Antiqua',
  'Underdog',
  'UnifrakturCook',
  'Unlock',
  'Vampiro One',
  'Vibur',
  'Vidaloka',
  'Volkhov',
  'Waiting for the Sunrise',
  'Warnes',
  'Wellfleet',
  'Wendy One',
  'Wire One',
  'Yeon Sung',
]

export const SYSTEM_FONT_OPTIONS = [
  { value: 'system', label: 'Sistema' },
  { value: 'serif', label: 'Serif clássica' },
  { value: 'sans', label: 'Sans moderna' },
]

export function isSystemFontFamily(family) {
  const f = String(family || '').toLowerCase()
  return f === 'system' || f === 'serif' || f === 'sans'
}

export function normalizeFontFamilyName(raw) {
  const value = String(raw || '').trim().slice(0, 80)
  if (!value) return 'Fraunces'
  const lower = value.toLowerCase()
  if (lower === 'fraunces') return 'Fraunces'
  if (isSystemFontFamily(lower)) return lower
  // Preserve Google Font casing when possible
  const match = GOOGLE_FONT_FAMILIES.find((f) => f.toLowerCase() === lower)
  return match || value
}
